import React from 'react';

const withProps = (Component, props) => {
    if (!Component) return null;
  return <Component {...props}/>;
};

export default withProps;
